document.addEventListener("DOMContentLoaded", function () {
    const imagesContainer = document.querySelector(".instagram-posts-container");
    if (
        imagesContainer &&
        imagesContainer.querySelectorAll("img[data-image]").length > 0
    ) {
        const images = imagesContainer.querySelectorAll("img[data-image]");
        convertImagesToBase64(images);
    }
});

let names = {};
$(".search-input").each(function () {
    let catName = $(this).attr("name").split("-")[0];
    let value = $(this).val(); // Use .val() to get the input value
    names[catName] = value;
});

const keyMappings = {
    instagram: {
        fullName: "user.full_name",
        userName: "user.user_name",
        profilePic: "user.profile_pic",
        posts: "user_posts",
        thumbnail: "thumbnail",
        postId: "id",
    },
    tiktok: {
        fullName: "full_name",
        userName: "user_name",
        profilePic: "profile_image",
        posts: "posts",
        thumbnail: "post_image",
        postId: "post_id",
    },
    youtube: {
        thumbnail: "thumbnail",
        postId: "video_id",
        posts: "",
        userName: "u_name",
    },
};

function keysHelper(standardKey, cat, data) {

    const catMappings = keyMappings[cat];
    if (!catMappings) {
        // console.log(`Unknown category: ${cat}`);
        return;
    }
    const keyPath = catMappings[standardKey];

    if (keyPath === "") {

        return data;
    }
    if (!keyPath) {
        // console.log(`Unknown standard key: ${standardKey} for category: ${cat}`);
        return;
    }
    const keys = keyPath.split(".");
    let value = data;
    for (const key of keys) {
        if (value === undefined || value === null) {
            // console.log(
            // 	`Invalid key path: ${keyPath} for data: ${JSON.stringify(data)}`
            // );
            return null;
        }
        value = value[key];
    }

    return value;
}

async function handleEvent(e) {
    var activeTabId;
    var username;
    var searchInput;
    var placeholder;
    var searchBtn;
    var dataHref;
    const isChanging = $(this).parent().hasClass("change-mode");
    let btnText = "";
    if (e.type === "keypress") {
        if (e.keyCode !== 13) {
            return;
        }
        searchInput = $(this);
        searchInput.blur();
        if ($(".quality_tabs").length > 0) {
            searchBtn = $(".quality_packages.active .searchBtn");
        } else {
            searchBtn = searchInput.siblings(".searchBtn");
        }
        dataHref = $(searchBtn).attr("data-href") || "";
        if (dataHref) e.preventDefault();
        activeTabId = searchBtn.attr("data-target");
        username = searchInput.val()?.trim();
        placeholder = searchInput.attr("placeholder");
    } else {
        dataHref = $(this).attr("data-href") || "";
        if (dataHref) e.preventDefault();
        searchBtn = $(this);
        searchInput = dataHref
            ? $(".search-input")
            : searchBtn.siblings(".search-input");
        activeTabId = searchBtn.attr("data-target");
        username = searchInput.val()?.trim();
        placeholder = searchInput.attr("placeholder");
    }
    if (!checkInput(searchInput[0])) {
        return;
    }
    const hrefData = dataHref.split("-");
    if(activeTabId=='youtube' || hrefData[1]=='youtube'){
        let channelNameRegex= /^https:\/\/(www\.|m\.)?youtube\.com\/(?!watch|shorts|live)(@[\w#-]+|c\/[\w-]+|channel\/[a-zA-Z0-9_-]+|user\/[\w-]+|[\w-]+)(\/.*)?(\?.*)?$/
        let videoLinkRegex=/^(https?:\/\/)?(www\.|m\.)?(youtu\.be\/|youtube\.com\/(watch\?.*?v=|embed\/|live\/|shorts\/))([a-zA-Z0-9_-]{11})([&?].*)?$/
        if(!channelNameRegex.test(username) && !videoLinkRegex.test(username) && !username.startsWith('https')){
            username='https://www.youtube.com/' + (username[0]=='@'?username:('@'+username));
        }
    }
    const userMapping = {
        instagram: {
            key: "ig_user_name",
            value: ig_user_name ? "" : "",
        },
        tiktok: {
            key: "tiktok_user_name",
            value: tiktok_user_name,
        },
        youtube: {
            key: "channel_name",
            value: channel_name,
        },
    };
    localStorage.removeItem("socialuser");
    if (!username && !dataHref) {
        return;
    }

    const cart = typeof cartData !== "undefined" ? cartData : {};
    if ((cart[activeTabId]?.u_name && cart[activeTabId].u_name === username)) {
        $(this).parent().css("display", "none");
        let element =
            $("." + activeTabId + "-user-name")?.length !== 0
                ? $("." + activeTabId + "-user-name")
                : $("." + activeTabId + "-user-id");
        element.closest(".active-mode").css("display", "flex");
        document
            .querySelectorAll(`.${activeTabId}-services .slider`)
            ?.forEach((e) => {
                e.disabled = false;
            });
        return;
    }
    let url = BASE_URL + "find/";
    let service_variant = document.querySelector(".pkg_variant");
    if (service_variant) {
        service_variant = service_variant.value || service_variant.innerText;
    }

    let allData = {
        userId,
        user_name: username,
        qty: hrefData[0],
        ctg: dataHref ? hrefData[1] : activeTabId,
        service: service_variant
            ? `${hrefData[2]},,${service_variant}`
            : hrefData[2],
        value:activeTabId
            ? userMapping[activeTabId]?.key
            : userMapping[hrefData[1]]?.key,
        action: "getMedia",
        //[csrfName]: csrfHash,
    };
    localStorage.setItem("serviceDatatoShow", JSON.stringify(allData));
    if (!activeTabId) {
        activeTabId = searchInput?.attr("name").split("-")[0];
    }
    if($(searchBtn).prop('tagName') == 'DIV'){
        searchBtn=$(searchBtn).find('button');
    }
    btnText = $(searchBtn).text();
    $(searchBtn).css("min-width", `${$(searchBtn).outerWidth()}px`);
    $(searchBtn).html('<div class="loader mx-auto"></div>');
    $(searchBtn).prop("disabled", true);
    let helpertabId = activeTabId;
    activeTabId = activeTabId == "threads" ? "thread" : activeTabId;
    if (isChanging) {
        allData.change = "change";
    } else if (
        username !== names[activeTabId] &&
        username !== names[helpertabId]
    ) {
        localStorage.setItem("socialuser", username);
    } else {
        localStorage.removeItem("socialuser");
        username = null;
    }
    let flag = false;
    if (allData.change !== "change" && allData.change !== "task") {
        let a = false;
        if (
            (names[activeTabId] && username && username !== names[activeTabId]) ||
            (names[helpertabId] && username && username !== names[helpertabId])
        ) {
            let cartData;
            if (typeof categoryCartInfo === "string") {
                cartData = JSON.parse(categoryCartInfo);
            } else {
                cartData = categoryCartInfo;
            }
            if (
                (cartData[activeTabId] && Object.keys(cartData[activeTabId])?.length) ||
                (cartData[helpertabId] && Object.keys(cartData[helpertabId])?.length)
            ) {
                a = await showDialogBox(
                    "Are you sure you want to change the user? Your cart data for " +
                    activeTabId +
                    " will be lost."
                );
            } else {
                a = true;
            }
        } else {
            a = true;
        }
        if (a) {
            $("#custom-loader").css("display", "flex");
            if (!username) {
                window.location.href = BASE_URL + allData.ctg + "/";
            }
            flag = true;
        } else {
            localStorage.removeItem("socialuser");
            searchInput.val(names[activeTabId] || names[helpertabId]);
            $(searchBtn).text(btnText);
            $(searchBtn).prop("disabled", false);
            return;
        }
    }
    let currentService = document.getElementById(
        `accordion-${activeTabId == "thread" ? "threads" : activeTabId}`
    );
    if (currentService) {
        let activeServices = currentService.querySelectorAll(
            ".service-checkbox:checked"
        );
        activeServices.forEach((e) => {
            e.click();
        });
    }
    if (username) {
        $(`.${activeTabId}-services .variant-radio`)?.each(function(){
            let checked=$(this).prop('checked');
            if(checked){
                $(this)?.click();
            }
            $(this).prop('checked', false);
        })
        $(`.${activeTabId}-services .post-input-check`)?.each(function(){
            $(this).prop('checked', false);
        });
        document
            .querySelectorAll(`.${activeTabId}-services .slider`)
            ?.forEach((e) => {
                e.disabled = true;
            });
        let result = await sendBecanAjax(url, allData, flag);
        if (!result) {
            delete cart[activeTabId];
            delete names[activeTabId];
            localStorage.removeItem("serviceDatatoShow");
        }
        $(searchBtn).text(btnText);
        $(searchBtn).prop("disabled", false);
        $("#custom-loader").hide();
        if (result && flag) {
            if(result.u_data?.channel_name){
                let serviceData = JSON.parse(localStorage.getItem("serviceDatatoShow"));
                if (serviceData) {
                    serviceData.user_name = result.u_data?.channel_name
                    localStorage.setItem("serviceDatatoShow", JSON.stringify(serviceData));
                    let socialuser=localStorage.getItem("socialuser");
                    if(socialuser){
                        localStorage.getItem("socialuser", result.u_data?.channel_name)
                    }
                }
            }
            window.location.href = BASE_URL + allData.ctg + "/";
            return;
        } else if (flag) {
            return;
        }
        if (result) {
            document
                .querySelectorAll(`.${activeTabId}-services .slider`)
                ?.forEach((e) => {
                    e.disabled = false;
                });
            let data = result;
            if (cartData[data.ctg]) {
                if(data?.u_data?.channel_name){
                    cartData[data.ctg].u_name = data.u_data.channel_name;
                    userNames[data.ctg]=data.u_data.channel_name;
                }else{
                    cartData[data.ctg].u_name = data.u_name;
                    userNames[data.ctg]=data.u_name;
                }
            }else{
                cartData[data.ctg]= {
                    u_name:data.u_data?.channel_name?data.u_data.channel_name:data.u_name
                }
                userNames[data.ctg]=data.u_data?.channel_name?data.u_data.channel_name:data.u_name;
            }
            updateUserData(data, data.ctg);
            expandAccordion(document.getElementById(`accordion-${data.ctg}`));
        }
    }
}
function updatdeCart(activeTabId) {
    //this is the function to update cart when user Change from order process page
    let newData = JSON.parse(JSON.stringify(cartData));
    if (
        typeof newData == "object" &&
        cartData[activeTabId == "thread" ? "threads" : activeTabId]
    ) {
        delete newData[activeTabId == "thread" ? "threads" : activeTabId];
        for (let k in newData) {
            if (newData[k]?.u_name) {
                for (let j in newData[k]) {
                    newData[k][j].u_name = newData[k].u_name;
                }
            }
            delete newData[k].u_name;
        }
        addToCart(newData);
    }
}

$(document).on("click", ".searchBtn", handleEvent);
$(document).on("keypress", ".search-input", handleEvent);
function updateUserData(data, cat) {
    let profileData = data.u_data || {};
    let userName = data.u_name;
    if (data.ctg == "tiktok") {
        profileData = data?.u_data?.profileData || {};
    } else if (data.ctg == "youtube") {
        profileData = data?.u_data?.youtubeChannel || {};
        userName=data?.u_data?.channel_name?data?.u_data?.channel_name:userName;
    }
    let profilePic = keysHelper("profilePic", cat, profileData);
    let fullName = keysHelper("fullName", cat, profileData);
    let posts = keysHelper("posts", cat, profileData);
    $("#accordion-" + cat + " .slider").prop("disabled", false);
    $(`[id^='${cat}'][id$='variant']`).prop("disabled", false);
    $(`[id^='${cat}'][id$='breakpoints']`).css("pointer-events", "all");
    $(`[id^='${cat}'][id$='duration']`).prop("disabled", false);
    if (profilePic || cat=='youtube') {
        if(!profilePic && cat=='youtube'){
            profilePic=profileData?.profile
                ?.profile_image?.[0];
        }
        $("." + cat + "-profile-pic").attr(
            "src",
            (cat === "instagram"
                ? BASE_URL + "proxy/image?url=" + encodeURIComponent(profilePic)
                : profilePic) || ""
        );
    }
    if (userName || cat=='youtube') {
        if(!userName && cat=='youtube'){
            userName=profileData?.profile?.username;
        }
        const validCategories = ['youtube', 'facebook', 'threads', 'twitter'];
        let flag = !validCategories.includes(cat);
        $("." + cat + "-user-id")?.text(userName?(flag?"@":'') + userName : "");
        $("." + cat + "-user-id")?.attr("href", userName);
        if(fullName){
            $("." + cat + "-user-name")?.text(fullName || "");
        }else if(cat=='youtube'){
            $("." + cat + "-user-name")?.text(profileData?.profile?.username || "");
        }
    }
    const activeMode = $("." + cat + "-user-id").closest(".active-mode");
    $(activeMode).css("display", "flex");
    $(activeMode).siblings(".change-mode").css("display", "none");
    let postsContainer = $("." + cat + "-posts-container");
    postsContainer.empty();
    if (posts?.length > 0) {
        posts.forEach((post) => {
            const postId = keysHelper("postId", cat, post);
            if(postId != null){
                const thumbnail = keysHelper("thumbnail", cat, post);
                let postHtml = `
                    <div class="image-wrapper min-w-fit relative inline-block">
						<div class="img-loader absolute inset-0 flex items-center justify-center bg-gray-300 hidden">
							<span></span>
						</div>
                        <img id="${postId}"
                            class="h-[60px] w-[60px] sm:h-[85px] sm:w-[85px] object-cover cursor-pointer rounded-lg selectable-image select-none d-none"
                            draggable="false"
                            data-image="${thumbnail}"
                            alt="post">
                        <div class="overlay absolute bottom-0 left-0 w-full bg-black text-white text-center text-sm sm:text-lg">
                        </div>
						${(cat=='tiktok' || (cat=='instagram' && post.is_video) )?
                    `<span class='video-icon top-1 left-1 bg-white absolute rounded-sm'>
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 61.1 61.1" width="15"
                                        height="15" style="enable-background:new 0 0 61.1 61.1;" xml:space="preserve">
                                        <g>
                                            <path class="st19"
                                                d="M57.4,41.4c-0.3,0.6-0.7,1-1.3,1.4c-1.1,0.6-2.4,0.6-3.5,0c-1.1-0.6-2.2-1.2-3.3-1.9   c-1.9-1.1-3.8-2.2-5.7-3.3c-0.4-0.2-0.5-0.4-0.5-0.9c0.2-4.2,0.5-8.3,0-12.5c-0.2-1.4,0.6-0.9,4.2-2.7c1.5-0.7,2.8-1.8,4.1-2.9   c2.6-2.2,5.9-0.8,6.3,1.9c0,0,0,0.1,0,0.1c0,6.2,0,12.4,0,18.6C57.9,40.2,57.8,40.8,57.4,41.4z" />
                                            <path class="st19"
                                                d="M21.6,46.6c-4.1,0-8.1,0-12.2,0c-3,0-5.4-1.8-6-4.6c-0.1-0.5-0.2-1-0.2-1.5c0-6.6,0-13.2,0-19.7   c0-3.6,2.5-6.2,6.1-6.2c8.2,0,16.5,0,24.7,0c3.5,0,6.1,2.5,6.1,6.1c0,6.7,0,13.3,0,20c0,3.6-2.6,6.1-6.2,6.1   C29.8,46.6,25.7,46.6,21.6,46.6z" />
                                        </g>
                                    </svg>
                                </span>`
                    :''
                }
                    </div>
                `;
                postsContainer.append(postHtml);
            }
            if (cat === "instagram") {
                const wrapper = postsContainer.lastElementChild;
                if (wrapper) {
                    const img = wrapper.querySelector('img');
                    const loader = wrapper.querySelector('.img-loader');
                    if (img && loader) {
                        if (img.complete) {
                            loader.classList.add('hidden');
                            img.classList.remove('d-none');
                        } else {
                            img.src = img.getAttribute('data-image');
                            loader.classList.remove('hidden');
                            img.classList.add('d-none');
                            img.addEventListener('load', () => {
                                loader.classList.add('hidden');
                                img.classList.remove('d-none');
                            });
                            img.addEventListener('error', () => {
                                loader.classList.add('hidden');
                                wrapper.insertAdjacentHTML('beforeend', '<p class="error-text text-red-500">Image failed to load.</p>');
                            });
                        }
                    } else {
                        // console.log('Image or loader not found.');
                    }
                } else {
                    // console.log('Wrapper element not found.');
                }
            }
        });
        const images = postsContainer.find("img[data-image]").toArray();
        if (cat == "instagram") {
            convertImagesToBase64(images);
        } else {
            images.forEach((img) => {
                img.src = img.dataset.image;
            });
        }

        $(".accordion-" + cat)
            .find(".selection-quantity")
            .text(0);
        const commentsDiv = $("." + cat + "-comments");
        if (commentsDiv.hasClass("hidden")) {
            commentsDiv.removeClass("hidden");
        }
    } else if(cat!=='youtube') {
        postsContainer.append(
            `<p class="text-center w-full pt-3 text-gray-500">Account has no videos.</p>`
        );
    }
    if (cat=='youtube'){
        posts?.videos?.forEach((post)=>{
            if(post.video_id==null)return;
            const postId = keysHelper("postId", cat, post);
            const thumbnail = keysHelper("thumbnail", cat, post);
            let postHtml = `
                    <div class="image-wrapper min-w-fit relative inline-block">
                        <img id="${postId}"
                            class="h-[60px] w-[60px] sm:h-[85px] sm:w-[85px] object-cover cursor-pointer rounded-lg selectable-image select-none d-none"
                            draggable="false"
							data-image="${thumbnail}"
                            src="${thumbnail}"
                            alt="post">
                        <div class="overlay absolute bottom-0 left-0 w-full bg-black text-white text-center text-sm sm:text-lg">
                        </div>
						 <span class='video-icon top-1 left-1 bg-white absolute rounded-sm'>
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 61.1 61.1" width="15"
                                        height="15" style="enable-background:new 0 0 61.1 61.1;" xml:space="preserve">
                                        <g>
                                            <path class="st19"
                                                d="M57.4,41.4c-0.3,0.6-0.7,1-1.3,1.4c-1.1,0.6-2.4,0.6-3.5,0c-1.1-0.6-2.2-1.2-3.3-1.9   c-1.9-1.1-3.8-2.2-5.7-3.3c-0.4-0.2-0.5-0.4-0.5-0.9c0.2-4.2,0.5-8.3,0-12.5c-0.2-1.4,0.6-0.9,4.2-2.7c1.5-0.7,2.8-1.8,4.1-2.9   c2.6-2.2,5.9-0.8,6.3,1.9c0,0,0,0.1,0,0.1c0,6.2,0,12.4,0,18.6C57.9,40.2,57.8,40.8,57.4,41.4z" />
                                            <path class="st19"
                                                d="M21.6,46.6c-4.1,0-8.1,0-12.2,0c-3,0-5.4-1.8-6-4.6c-0.1-0.5-0.2-1-0.2-1.5c0-6.6,0-13.2,0-19.7   c0-3.6,2.5-6.2,6.1-6.2c8.2,0,16.5,0,24.7,0c3.5,0,6.1,2.5,6.1,6.1c0,6.7,0,13.3,0,20c0,3.6-2.6,6.1-6.2,6.1   C29.8,46.6,25.7,46.6,21.6,46.6z" />
                                        </g>
                                    </svg>
                                </span>
                    </div>
                `;
            postsContainer.append(postHtml);
        })
        posts?.shorts?.forEach((post)=>{
            if(post.video_id==null)return;
            const postId = keysHelper("postId", cat, post);
            const thumbnail = keysHelper("thumbnail", cat, post);
            let postHtml = `
                    <div class="image-wrapper min-w-fit relative inline-block shortViews hidden">

                        <img id="${postId}"
                            class="h-[60px] w-[60px] sm:h-[85px] sm:w-[85px] object-cover cursor-pointer rounded-lg selectable-image select-none d-none"
                            draggable="false"
                            data-image="${thumbnail}"
							src="${thumbnail}"
                            alt="post">
                        <div class="overlay absolute bottom-0 left-0 w-full bg-black text-white text-center text-sm sm:text-lg">
                        </div>
						 <span class='video-icon top-1 left-1 bg-white absolute rounded-sm'>
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 61.1 61.1" width="15"
                                        height="15" style="enable-background:new 0 0 61.1 61.1;" xml:space="preserve">
                                        <g>
                                            <path class="st19"
                                                d="M57.4,41.4c-0.3,0.6-0.7,1-1.3,1.4c-1.1,0.6-2.4,0.6-3.5,0c-1.1-0.6-2.2-1.2-3.3-1.9   c-1.9-1.1-3.8-2.2-5.7-3.3c-0.4-0.2-0.5-0.4-0.5-0.9c0.2-4.2,0.5-8.3,0-12.5c-0.2-1.4,0.6-0.9,4.2-2.7c1.5-0.7,2.8-1.8,4.1-2.9   c2.6-2.2,5.9-0.8,6.3,1.9c0,0,0,0.1,0,0.1c0,6.2,0,12.4,0,18.6C57.9,40.2,57.8,40.8,57.4,41.4z" />
                                            <path class="st19"
                                                d="M21.6,46.6c-4.1,0-8.1,0-12.2,0c-3,0-5.4-1.8-6-4.6c-0.1-0.5-0.2-1-0.2-1.5c0-6.6,0-13.2,0-19.7   c0-3.6,2.5-6.2,6.1-6.2c8.2,0,16.5,0,24.7,0c3.5,0,6.1,2.5,6.1,6.1c0,6.7,0,13.3,0,20c0,3.6-2.6,6.1-6.2,6.1   C29.8,46.6,25.7,46.6,21.6,46.6z" />
                                        </g>
                                    </svg>
                                </span>





                    </div>
                `;
            postsContainer.append(postHtml);
        })
        if(posts?.shorts?.length==0 && posts?.videos?.length==0){
            postsContainer.append(
                `<p class="text-center w-full pt-3 text-gray-500">Account has no videos.</p>`
            );
        }
    }
}
function sendBecanAjax(url, allData, flag) {
    if (!flag) {
        updatdeCart(allData.ctg);
    }
    return new Promise((resolve, reject) => {
        // Adding CSRF token to data
        allData[csrfName] = csrfHash;
        $.ajax({
            url: url,
            type: "POST",
            data: allData,
            contentType: "application/x-www-form-urlencoded",
            success: function (response) {
                let result = JSON.parse(response);
                if (!result.success) {
                    if (result.ctg === "youtube") {
                        createToast("error", result?.u_data?.message);
                    } else {
                        createToast("error", "Profile not found");
                    }
                    resolve(false);
                } else if (result.success == 2) {
                    resolve(false);
                    createToast("error", result.u_data.message);
                } else {
                    resolve(result);
                }
            },
            error: function (xhr, status, error) {

                createToast("error", error);
                resolve(false);
            },
        });
    });
}

async function convertImagesToBase64(images) {
    var defaultImageUrl = BASE_URL + "assets/images/instagram.svg";
    var imageUrls = Array.from(images)
        .map((img) => img.dataset.image)
        .filter((url) => url !== defaultImageUrl);
    await loadAllImages(imageUrls);
}

async function loadAllImages(imageUrls) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: BASE_URL + "proxy/image/",
            method: "POST",
            cache: false,
            data: {
                imageUrls: imageUrls,
                [csrfName]: csrfHash,
            },
            success: function (response) {
                if (response && response.length) {
                    var images = JSON.parse(response);
                    images.images.forEach(function (imageData) {
                        var imgElements = document.querySelectorAll(
                            `img[data-image="${imageData.url}"]`
                        );
                        imgElements.forEach(function (imgElement) {
                            var loaderElement = imgElement.previousElementSibling;
                            imgElement.src = imageData.base64;
                            $(imgElement)
                                .on("load", function () {
                                    $(loaderElement).hide();
                                    imgElement.style.display = "block";
                                })
                                .on("error", function () {
                                    $(loaderElement).hide();
                                    console.error("Error loading image: " + imageData.url);
                                });
                        });
                    });

                    resolve();
                } else {
                    reject("No images returned from server.");
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("Error fetching images:", textStatus, errorThrown);
                reject("Error in AJAX request.");
            },
        });
    });
}

function showDialogBox(message) {
    return new Promise((resolve) => {
        const overlay = document.createElement("div");
        overlay.className = "fixed inset-0 flex items-center justify-center z-50";
        overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        const dialogBox = document.createElement("div");
        dialogBox.className =
            "bg-[#FEFEFA] rounded-lg shadow-lg p-3 w-[90%] sm:p-6 sm:w-[380px]";
        const messageElement = document.createElement("p");
        messageElement.className = "text-[#FF4754] text-lg mb-4";
        messageElement.textContent = message;
        const buttonsContainer = document.createElement("div");
        buttonsContainer.className = "flex justify-end space-x-4";
        const yesButton = document.createElement("button");
        yesButton.className = "bg-[#FF4754] text-white px-4 py-2 rounded";
        yesButton.textContent = "Yes";
        yesButton.addEventListener("click", () => {
            document.body.removeChild(overlay);
            resolve(true);
        });
        const noButton = document.createElement("button");
        noButton.className =
            "text-[#FF4754] border-2 border-[#FF4754] px-4 py-2 rounded";
        noButton.textContent = "No";
        noButton.addEventListener("click", () => {
            document.body.removeChild(overlay);
            resolve(false);
        });
        buttonsContainer.appendChild(yesButton);
        buttonsContainer.appendChild(noButton);
        dialogBox.appendChild(messageElement);
        dialogBox.appendChild(buttonsContainer);
        overlay.appendChild(dialogBox);
        document.body.appendChild(overlay);
    });
}
